<template>
	<div>
		<div class="container-fluid right_wrapper">
			<TemplateHeader @getList = "getList"/>
			<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px"></div>
			<div v-else>
				<div v-if = "((list && list.length)||(templateList && templateList.length))">
					<TemplateListGrid class="table_wrap no_footer" @getList = "getList" />
				</div>
				<div v-else>
					<NoDataAvailable displayMessage="No Data Is Available" ></NoDataAvailable>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import TemplateHeader from "./TemplateHeader.vue"
import TemplateListGrid from "./TemplateListGrid.vue"
import NoDataAvailable from '@/components/NoDataAvailable.vue'


export default {
	name: "Template",
	components:{
		TemplateHeader,
		TemplateListGrid,
		NoDataAvailable
	},
	data(){
		return{
			showLoader:false,
			list:[]
		}
	},
	computed:{
		templateList:{
				set(val) {
					this.$store.commit("template/getTemplateList", val);
				},
				get() {
					return this.$store.state.template.templateList;
				}
			},
			sort: {
				set(val) {
					this.$store.commit("setSelectedSortOrder", val);
				},
				get() {
					return this.$store.state.selectedSortOrder;
				}
			}
	},
	watch:{
		sort() {
			this.getList();
		}
	},
	mounted(){
		if(this.$store.state.calledFromCancel){
			this.$store.state.calledFromCancel = false
		}
		else{
			this.sort = {
				field:'created_on',
				order:'desc'
			}
			this.getList()
		}

	},
	methods:{
		goBack(){
			this.sort={
				field:"name",
				order:"asc"
			}
			this.$store.state.template.tempOwner = 'Me';
			let path = this.$store.state.release.pathBeforeReleaseNote

			if(path){
				this.$router.push({path:path});
				this.$store.state.release.pathBeforeReleaseNote = ''
			}
			else{
				this.$router.push({path:'/campaignList'})
			}

		},
		getList(){
			let vm = this;
			this.showLoader = true;

			this.$store.dispatch('template/getTemplateList').then((res) => {
				vm.list = res
				vm.showLoader = false;
			})
		},
		beforeDestroy(){
			this.sort={
				field:"name",
				order:"asc"
			}
		}
	}
}
</script>
